import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";
import { IUseFormResponse } from "@/interfaces/activityFeedNotifications";

export const AcknowlegementPostConstants = {
    responseMessage : "Confirmed",
    deletedBannerMessage : "Content Archived"
}

export function useFormResponse({isPopOut, timeStamp, dateStamp, parentList, onDownloadCSVClick, content, appDetails}: IUseFormResponse) {
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const showDeletedBanner = content.isArchived;
    const activityInfo = {
        className: screenClassName, 
        time: isPopOut ? timeStamp : undefined, 
        contentTitle: parentList?.title,
        contentLink: parentList?.link,
        appImageUrl: appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "",
        appName: appDetails.isMultipleAppOrganisation ? appDetails.name : "",
        dateStamp: `${timeStamp} · ${dateStamp}`
    }

    const downloadCSVLink = !content.isArchived ? downloadCSV : undefined;
    
    function downloadCSV(e?: any) {
        useHaltPropagation(e);
        onDownloadCSVClick();
    }
    
    return { screenClassName, showDeletedBanner, downloadCSVLink, activityInfo }
};